

import { axiosPlacement } from "./AxiosInstance";


const API_URL = "/jobappliedstudents";


// ✅ Get all applied students
export const getAppliedStudents = async (limit = 10, page = 1, search = "", filters = {}) => {
  try {
    let url = `${API_URL}/full-data-list?limit=${limit}&page=${page}&search=${search}`;
    
    // Add additional filters to the URL
    Object.keys(filters).forEach(key => {
      if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
        url += `&${key}=${encodeURIComponent(filters[key])}`;
      }
    });

    const response = await axiosPlacement.get(url);
    return response.data;
  } catch (error) {
    throw new Error(`Failed to fetch applied students: ${error.message}`);
  }
};

// ✅ Get full data list (alias for getAppliedStudents with full-data-list endpoint)
export const getFullDataList = async (limit = 10, page = 1, search = "") => {
  return getAppliedStudents(limit, page, search);
};

// ✅ Search applied students with complex filters (grouped by student)
export const searchAppliedStudents = async (payload) => {
  try {
    const response = await axiosPlacement.post(`${API_URL}/jobAppliedStudents`, payload);
    return response.data;
  } catch (error) {
    throw new Error(`Failed to search applied students: ${error.message}`);
  }
};

// ✅ Get single applied student by ID
export const getAppliedStudentById = async (id) => {
  try {
    const response = await axiosPlacement.get(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(`Failed to fetch applied student: ${error.message}`);
  }
};

// ✅ Create new applied student
export const createAppliedStudent = async (studentData) => {
  try {
    const response = await axiosPlacement.post(`${API_URL}`, studentData);
    return response.data;
  } catch (error) {
    throw new Error(`Failed to create applied student: ${error.message}`);
  }
};

// ✅ Update applied student (PUT - full update)
export const updateAppliedStudent = async (id, updatedFields) => {
  try {
    const response = await axiosPlacement.put(`${API_URL}/${id}`, updatedFields);
    return response.data;
  } catch (error) {
    throw new Error(`Failed to update applied student: ${error.message}`);
  }
};

// ✅ Get student applied jobs
export const getStudentAppliedJobs = async (studentId, page = 1) => {
  try {
    const response = await axiosPlacement.get(`${API_URL}/student-applied-jobs?studentId=${studentId}&page=${page}`);
    return response.data;
  } catch (error) {
    throw new Error(`Failed to fetch student applied jobs: ${error.message}`);
  }
};


// ✅ Delete applied student
export const deleteAppliedStudent = async (id) => {
  try {
    await axiosPlacement.delete(`${API_URL}/${id}`);
    return id;
  } catch (error) {
    throw new Error(`Failed to delete applied student: ${error.message}`);
  }
};

// ✅ Delete multiple applied students by IDs
export const deleteAppliedStudentsBulk = async (ids) => {
  try {
    await axiosPlacement.post(`${API_URL}/bulk-delete`, { ids });
    return ids;
  } catch (error) {
    throw new Error(`Failed to delete applications: ${error.message}`);
  }
};

